export enum CollectionSortOrder {
  Descending = 'DESC',
  Ascending = 'ASC',
}
